<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="500px"
    scrollable
    @keydown.esc="dialog = false"
  >
    <card>
      <card-title>Изменение названий</card-title>
      <card-content class="pt-6">
        <v-row>
          <v-col cols="12">
            <v-text-field
              id="form-text-input-title"
              v-model="title"
              label="Название"
              outlined
              dense
              hide-details
            />
          </v-col>
        </v-row>
      </card-content>
      <card-actions>
        <v-btn
          id="add-product-btn-execute"
          color="primary"
          depressed
          @click="onExecute"
        >
          Выполнить
        </v-btn>
        <v-btn
          id="add-product-btn-cancel"
          color="primary"
          depressed
          outlined
          @click="dialog = false"
        >
          Отменить
        </v-btn>
      </card-actions>
    </card>
  </v-dialog>
</template>
<script>
export default {
  name: "MassAssignmentNames",
  model: {
    prop: "open",
    event: "change"
  },
  props: {
    open: Boolean
  },

  data() {
    return {
      title: ""
    };
  },

  computed: {
    dialog: {
      get() {
        return this.open;
      },
      set(value) {
        this.$emit("change", value);
      }
    }
  },

  watch: {
    open(newVal) {
      if (newVal) {
        this.resetForm();
      } else if (!newVal) {
        this.$emit("close");
      }
    }
  },

  methods: {
    async onExecute() {
      const { title } = this;
      this.$emit("apply", { val: title });
      this.dialog = false;
    },
    resetForm() {
      this.title = "";
    }
  }
};
</script>
